import '../../lib/scroll-timeline.js'
import { getElementTag } from '../../lib/get-element-tag.ts'
import { config } from './config.ts'
import { initIntro4 } from './intro/intro-4.ts'
import '@nrk/core-design-tokens/dist/color/nrk-color-tokens.css'
import './tema.css'
import './intro/intro.css'
import './intro/intro-1.css'
import './intro/intro-3.css'
import './intro/intro-4.css'

const tag = getElementTag(__APP_NAME__, config.moduleName, __APP_VERSION__)

class AppElement extends HTMLElement {
  connectedCallback() {
    initIntro4()

    const headings = Array.from(document.querySelectorAll('.dh-sa-text > h2'))
    for (const heading of headings) {
      // @ts-ignore
      const timeline = new ViewTimeline({ axis: 'block', subject: heading })

      // eslint-disable-next-line compat/compat
      const effect = new KeyframeEffect(heading, { opacity: [0.2, 1] }, { fill: 'both' })

      // eslint-disable-next-line compat/compat
      const animasjon = new Animation(effect, timeline)

      // @ts-ignore
      animasjon.rangeEnd = {
        rangeName: 'cover',
        // eslint-disable-next-line compat/compat
        offset: CSS.percent(50),
      }

      animasjon.play()
      // eslint-disable-next-line promise/always-return,promise/catch-or-return
      animasjon.finished.then(() => {
        animasjon.cancel()
      })
    }
  }
}

if (customElements.get(tag) === undefined) {
  customElements.define(tag, AppElement)
}
